import { Container, Text } from '@audio-network/componentlibrary'
import { useTranslation } from 'next-i18next'
import React from 'react'

import styles from './DownloadAlert.module.css'

const DownloadAlert = ({ user }: { user: User }): JSX.Element => {
	const { t } = useTranslation(['search'])

	if (
		!user ||
		user.organisation.canDownload ||
		!user.organisation.isSalesManaged
	)
		return null
	return (
		<Container className={styles.downloadAlertMessage} maxWidth="large">
			<Text variant="bodyS" color="textInverse">
				{t('no-downloads-1')}{' '}
				<a href="/contact" target="_blank">
					{t('no-downloads-2')}
				</a>{' '}
				{t('no-downloads-3')}
			</Text>
		</Container>
	)
}

export default DownloadAlert
